import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=489b5014&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"
import style0 from "./Home2.vue?vue&type=style&index=0&id=489b5014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b5014",
  null
  
)

export default component.exports